import { useLayoutMode } from '@/hooks/use-layout-mode';

import AppLayout from '../AppLayout';
import BackgroundLayout from '../BackgroundLayout';
import SplitLayout from '../SplitLayout';

const LayoutRouter = () => {
  const layout = useLayoutMode();

  switch (layout) {
    case 'split': {
      return <SplitLayout />;
    }
    case 'background': {
      return <BackgroundLayout />;
    }
    case 'default': {
      return <AppLayout />;
    }
  }
};

export default LayoutRouter;
